import { useEffect, useRef, useState } from 'react'
import Geosuggest from '@ubilabs/react-geosuggest'
import Pin from '@assets/pin.svg'
import styles from './Input.module.css'
import {
  getAddressCountry,
  getAddressState,
  getAreaForCountry,
} from '@src/helpers'

const handleSubmit = (e) => {
  e.preventDefault()
  return false
}

const onKeypress = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault()
    return false
  }
}

export function Placeholder({
  defaultValue,
  loading,
  scriptLoaded,
  disabled,
  style,
}) {
  const inputEl = useRef(null)
  return (
    <form onSubmit={handleSubmit} style={style}>
      <div className={styles.locationField}>
        <input
          type="text"
          ref={inputEl}
          placeholder="City (required)"
          defaultValue={defaultValue?.formatted_address}
          className={styles.inputFieldSearch}
          onChange={onKeypress}
          disabled={loading || disabled}
        />
        <Pin className={styles.pin} />
      </div>
    </form>
  )
}

export function RealLocationInput({
  home,
  defaultValue,
  markRequired,
  loading,
  scriptLoaded,
  disabled,
  style,
  handleUpdate,
  pinStyle,
}) {
  const inputEl = useRef(null)
  const [doBlur, setDoBlur] = useState(false)
  const [isBlurring, setIsBlurring] = useState(false)
  const [value, setValue] = useState(null)

  useEffect(() => {
    if (home && doBlur === true && !isBlurring) {
      setIsBlurring(true)
      setDoBlur(false)

      setTimeout(() => {
        if (!value) {
          inputEl.current.clear()
        } else {
          inputEl.current.update(value?.formatted_address)
        }
      }, 10)

      setTimeout(() => {
        setIsBlurring(false)
        setDoBlur(false)
      }, 100)
    }
  }, [doBlur])

  const handleBlur = () => {
    console.log('setting blurrr')
    setDoBlur(true)
  }

  const handleChange = (value) => {
    if (!value) {
      setValue(null)
    }
  }

  const onSuggestSelect = (value, data) => {
    if (value?.description) {
      inputEl.current.blur()
    }

    const country = getAddressCountry(value)
    const territory = getAddressState(value)

    const location = {
      formatted_address: value?.description ?? '',
      regions: {
        region: country ? `${country}_${territory}`.toLowerCase() : '',
        area: getAreaForCountry(country),
        country: country ? country.toLowerCase() : '',
      },
      coordinate: {
        lat: value?.location?.lat ?? '',
        lon: value?.location?.lng ?? '',
      },
    }
    handleUpdate(location)
    setValue(location)
  }

  if (!scriptLoaded) {
    return (
      <form onSubmit={handleSubmit} style={style} autoComplete="false">
        <div
          className={`${styles.locationField} ${styles.placeholderLocation}`}
        >
          <input
            className={styles.inputFieldSearchPlaceholder}
            placeholder="City (required)"
          />
          <Pin className={styles.pin} />
        </div>
      </form>
    )
  }

  let classes
  let textPlaceholder

  if (markRequired) {
    classes = `${styles.inputFieldSearch} ${styles.markRequired}`
    textPlaceholder = 'City (required)*'
  } else {
    classes = styles.inputFieldSearch
    textPlaceholder = 'City (required)'
  }

  return (
    <form onSubmit={handleSubmit} style={style} autoComplete="false">
      <div className={styles.locationField}>
        <Geosuggest
          placeholder={textPlaceholder}
          autoComplete="nope"
          className={classes}
          suggestsClassName={styles.suggestList}
          onSuggestSelect={onSuggestSelect}
          initialValue={defaultValue?.formatted_address}
          types={['(cities)']}
          onBlur={handleBlur}
          queryDelay={0}
          onChange={handleChange}
          ref={inputEl}
        />
        <Pin className={styles.pin} style={pinStyle} />
      </div>
    </form>
  )
}
